module.exports = __webpack_public_path__ + "static/bootstrap-761d8d59e4936a7063db84d4b7fae58a.jpg";